<template>
    <div>
        <b-modal
            :title="$t('form.label.reason')"
            :okOnly="true"
            :no-close-on-esc="true"
            :no-close-on-backdrop="true"
            @hide="onHideHandler($event)"
            :id="'reasonModal-' + target.id"
        >
            <b-form-group>
                <b-form-textarea
                    :id="`reason-textarea-${target.id}`"
                    v-model="reason"
                    :placeholder="$t('form.placeholder.reason')"
                    :aria-describedby="`reason-textarea-feedback-${target.id}`"
                />
            </b-form-group>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'ReasonModal',
    props: {
        target: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            reason: '',
        }
    },
    methods: {
        onHideHandler() {
            this.$emit('hide', {
                id: this.target.id,
                reason: this.reason.trim(),
            })
        },
    },
}
</script>
